import { render, staticRenderFns } from "./touPiaoDetail.vue?vue&type=template&id=13927411&scoped=true&"
import script from "./touPiaoDetail.vue?vue&type=script&lang=js&"
export * from "./touPiaoDetail.vue?vue&type=script&lang=js&"
import style0 from "./touPiaoDetail.vue?vue&type=style&index=0&id=13927411&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13927411",
  null
  
)

export default component.exports